import React from "react";
import { useState } from "react";
import { Typography, Button } from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import EditTask from "./components/edit-task";
import TaskList from "./components/task-list";
import useStyles from "./styles";

const Tasks = () => {
  const classes = useStyles();
  const [editTask, setEditTask] = useState(false);

  return (
    <div className={classes.root}>
      <Typography className={classes.header}>Tasks</Typography>
      <TaskList />
      {editTask ? (
        <EditTask
          onClose={() => setEditTask(false)}
          oldTitle=""
          oldDescription=""
          beingEdited={false}
        />
      ) : (
        <Button className={classes.addButton} onClick={() => setEditTask(true)}>
          <AddCircleOutlineIcon className={classes.addIcon} />
          <Typography className={classes.addButtonText}>Add Task</Typography>
        </Button>
      )}
    </div>
  );
};

export default Tasks;
